<h2 class="terra-headline-3 section-heading">{{ sectionTitle }}</h2>
<p class="terra-body section-desc">
  Please answer the following questions regarding your performance this quarter. All questions are required.
</p>

<div [formGroup]="form">
  <div formArrayName="managerQuestions">
    @for (ctrl of questionCtrls; track ctrl; let idx = $index) {
      <h2 class="terra-title-small section-question-heading">{{ questions[idx].title }}</h2>
      <p class="terra-body section-question-desc">{{ questions[idx].question }}</p>

      @if (isMeeting || isManager) {
        @if (isMeeting) {
          <p>{{ discussion.manager | userName }}</p>
        }

        <nty-textarea
          [formControl]="form.controls.managerQuestions.controls[idx]"
          label="Description"
          placeholder="Response..." />
      }

      @if (isMeeting || isManagee) {
        @if (isMeeting) {
          <p>{{ discussion.managee | userName }}</p>
        }

        <nty-textarea
          [formControl]="form.controls.manageeQuestions.controls[idx]"
          label="Description"
          placeholder="Response..." />
      }
    }
  </div>
</div>
